<template>
  <div class="max-centred text-center">
    <h1 class="text-h2">GitHub Azure Connector</h1>
    <h4 class="text-h4 my-12">Connect your GitHub account with your Beezlabs Azure account</h4>
    <p>
      This connection helps you in using GitHub and Azure features in internal Beezlabs tools like the Backstage
      Developer portal.
    </p>
    <p>
      In order to link your accounts successfully, first, please go to your GitHub account and add your Beezlabs email.
      See the following
      <a
        href="https://docs.github.com/en/account-and-profile/setting-up-and-managing-your-personal-account-on-github/managing-email-preferences/adding-an-email-address-to-your-github-account"
      >
        docs
      </a>
      if you need help in doing the same.
    </p>
    <p>The, click on the "Link" button below and accept the prompt from GitHub when it comes up.</p>
    <p>
      If you have previously linked you accounts and your data has changed, you can click on "Link" again to update your
      data. You can check if you have previously linked and what data is linked by clicking on "Check" button below.
    </p>
    <p class="mt-8">
      <v-btn color="primary" class="ma-2" :href="linkURL">Link</v-btn>
      <v-btn color="secondary" class="ma-2" @click="check">Check</v-btn>
    </p>

    <div v-if="userData">
      <p>
        <v-img :src="userData.github_avatar_url" max-height="100" max-width="100" class="mx-auto rounded-circle" />
      </p>
      <p>Azure OID: {{ userData.azure_oid }}</p>
      <p>Display Name: {{ userData.display_name }}</p>
      <p>Email: {{ userData.email }}</p>
      <p>GitHub ID: {{ userData.github_id }}</p>
      <p>
        GitHub Username: <a :href="userData.github_html_url">{{ userData.github_login }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { nanoid } from 'nanoid'

export default {
  name: 'LandingPage',
  data: () => ({
    linkURL: null,
    userData: null
  }),
  created() {
    const state = nanoid()
    localStorage.githubState = state
    this.linkURL = process.env.VUE_APP_SERVER + process.env.VUE_APP_GH_OAUTH_ENDPOINT + '/login?state=' + state
  },
  methods: {
    async check() {
      this.userData = await this.$store.dispatch('check')
    }
  }
}
</script>

<style scoped>
.max-centred {
  max-width: 700px;
  margin: 0 auto;
}
</style>
